import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "checkboxes"]

  syncCheckbox() {
    const selectedId = this.selectTarget.value
    if (!selectedId) return

    const checkbox = this.checkboxesTarget.querySelector(
      `input[type="checkbox"][value="${selectedId}"]`
    )
    if (checkbox && !checkbox.checked) {
      checkbox.checked = true
      checkbox.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
